import React from 'react';
import { SwipeableHandlers } from 'react-swipeable';
import { Slide } from '@material-ui/core';
import NoPreview from './NoPrivew';

import { Article } from '../../../../../types/items';
import { getLargeDocumentThumbnailUrl } from '../utils';
import MediaPreviewStyles from './styles';

type Props = {
  media: Article;
  swipeable?: SwipeableHandlers;
  slideDirection: 'left' | 'right' | 'up' | 'down';
  isChangePreviewMedia: number | null;
};

const MediaOther = ({ media, swipeable, slideDirection, isChangePreviewMedia }: Props) => {
  const classes = MediaPreviewStyles();
  const documentRenderState = media.ref.document?.pages_render_state_id;
  const isProcessingMedia = documentRenderState === 0 || documentRenderState === 1;
  const thumbnails = media.ref.document?.thumbnails || [];

  if (isProcessingMedia) {
    return <NoPreview
      swipeable={swipeable}
      slideDirection={slideDirection}
      isChangePreviewMedia={isChangePreviewMedia}
    />;
  }

  return (
    <Slide
      direction={slideDirection}
      in={isChangePreviewMedia === null}
      mountOnEnter
      unmountOnExit
      timeout={300}
    >
      <div {...swipeable} className={classes.wrapper}>
        <img src={getLargeDocumentThumbnailUrl(thumbnails)} alt="" className={classes.image} />
      </div>
    </Slide>
  );
};

export default MediaOther;
